import { CountrySelectContext } from "contexts/CountrySelectContext";
import { useContext } from "react";

export const useCountry = () => {
  const context = useContext(CountrySelectContext);
  if (!context) {
    throw new Error("useCountry must be used within a CountrySelectProvider");
  }
  return context;
};
